import { Container } from '@mantine/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useEventStore } from '../../../store';
import { Header } from '../navigation';
import { QuickEnrollContent } from './QuickEnrollContent';

export const QuickEnrollPage = observer(() => {
  const eventStore = useEventStore();

  useEffect(() => {
    eventStore.loadEvents();
  }, [eventStore]);

  return (
    <Container fluid w="100vw" h="auto" p={0} style={{ overflow: 'clip' }}>
      <Header hideLogout />
      <QuickEnrollContent events={eventStore.events} />
    </Container>
  );
});
